import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import { IMenuItem } from 'shared/types/menu.interfaces';
import { CustomMuiIcon } from 'assets/images/icons/customMuiIcons';
import { useCheckPage } from 'shared/hooks/useCheckPage';
import { urls } from 'shared/constants/routing.constants';
import { selectSpecialPage } from 'redux/selectors/selectors';
import { useAppSelector } from 'redux/hooks/reduxHooks';
import { useGetAllChallengesQuery } from 'redux/api/challenge.api';
import { useGetAllDebatesQuery } from 'redux/api/debate.api';
import { MAIN_MENU } from 'shared/constants/menu-constants';
import { GoToTopButton } from 'components/Button/GoToTopButton/GoToTopButton';

interface IPageContainerProps {
  children: ReactNode;
  showMenu?: boolean;
}

export const PageContainer: React.FunctionComponent<IPageContainerProps> = ({
  children,
  showMenu = true,
}) => {
  const location = useLocation();
  const currentPage = useAppSelector(selectSpecialPage);
  const { refetch: refetchAllChallenges } = useGetAllChallengesQuery();
  const { refetch: refetchAllDebates } = useGetAllDebatesQuery();
  const checkPage = useCheckPage(currentPage);

  const mainMenu: IMenuItem[] = [
    {
      name: MAIN_MENU.Debates,
      imageNormal: 'icon-fire-outlined',
      imageSelected: 'icon-fire-filled',
      onClick: () => checkPage(urls.commonPages.home),
      onUpdate: () => refetchAllDebates(),
      isSelected: location.pathname === urls.commonPages.home,
    },
    {
      name: MAIN_MENU.Challenges,
      imageNormal: 'icon-clock-outlined',
      imageSelected: 'icon-clock-filled',
      onClick: () => checkPage(urls.commonPages.challenges),
      onUpdate: () => refetchAllChallenges(),
      isSelected: location.pathname === urls.commonPages.challenges,
    },
    // {
    //   name: MAIN_MENU.Help,
    //   imageNormal: 'icon-help-outlined',
    //   imageSelected: 'icon-help-filled',
    //   onClick: () => checkPage(urls.commonPages.help),
    //   isSelected: location.pathname === urls.commonPages.help,
    // },
  ];

  return (
    <>
      {showMenu && (
        <Stack
          sx={{
            minWidth: { lg: 246, md: 'min-content', sm: 'min-content', xs: 'min-content' },
            height: { lg: 'calc(100vh - 104px)', md: 'calc(100vh - 76px)' },
            padding: '28px 20px 28px 0',
            // rowGap: '4px',
            boxShadow: (theme) => `4px 0 10px 0 ${theme.palette.myGrey.grey70}`,
            display: { md: 'flex', sm: 'none', xs: 'none' },
            position: 'sticky',
            top: { lg: '104px', md: '76px' },
          }}
        >
          <Stack
            sx={{
              rowGap: '4px',
              position: 'sticky',
              top: { lg: '132px', md: '104px' },
            }}
          >
            {mainMenu.map((item: IMenuItem, index: number) => (
              <Button
                variant="mainMenu"
                key={index}
                className={`${item.isSelected ? 'selected' : ''}`}
                onClick={() => (item.isSelected ? item.onUpdate?.() : item.onClick())}
              >
                {item.isSelected ? (
                  <CustomMuiIcon type={item.imageSelected} size="42px" />
                ) : (
                  <CustomMuiIcon type={item.imageNormal} size="42px" />
                )}
                {item.name}
              </Button>
            ))}
          </Stack>
        </Stack>
      )}
      <Box
        sx={{
          width: '100%',
          padding: { md: showMenu ? '30px 0 102px 42px' : '30px 0 102px', xs: '40px 0 40px' },
          position: 'relative',
        }}
        id="scrollable-container"
      >
        {children}
        <GoToTopButton />
      </Box>
    </>
  );
};

export default PageContainer;
